<template>
  <Select :value="localValue" :label="label" :shortTitle="shortTitle" :options="options" :v="v" :required="required" @input="handleChange" :help="help" />
</template>

<script>
import Select from './Select'
export default {
  name: 'Nationality',
  components: {
    Select
  },
  props: {
    label: String,
    v: Object,
    required: [Boolean, Number],
    value: [String, Number, Object],
    help: String,
    id: String,
    shortTitle: String
  },
  data () {
    return {
      localValue: null,
      options: ['Afghaans', 'Albanees', 'Algerijns', 'Amerikaans', 'Amerikaans (Puerto Rico)', 'Angolees', 'Argentijns', 'Armeens', 'Australisch', 'Azerbeidzjaans', 'Belgisch', 'Belizaans', 'Bengaals', 'Benins', 'Boliviaans', 'Bosnisch', 'Braziliaans', 'Brits', 'Bulgaars', 'Burkinees', 'Burundisch', 'Cambodjaans', 'Canadees', 'Chileens', 'Chinees', 'Colombiaans', 'Congolees', 'Costaricaans', 'Cubaans', 'Cyprisch', 'Deens', 'Dominicaans', 'Duits', 'Ecuadoraans', 'Egyptisch', 'Eritrees', 'Estlands', 'Ethiopisch', 'Filippijns', 'Fins', 'Frans', 'Georgisch', 'Ghanees', 'Grenadaans', 'Grieks', 'Guatemalteeks', 'Guinees', 'Haïtiaans', 'Hondurees', 'Hongaars', 'Hongkong', 'Iers', 'IJslands', 'Indiaas', 'Indonesisch', 'Iraaks', 'Iraans', 'Israëlisch', 'Italiaans', 'Ivoriaans', 'Japans', 'Jemenitisch', 'Jordaans', 'Kameroens', 'Kazachstaans', 'Keniaas', 'Kirgizisch', 'Kongolees (Kinshasa)', 'Koreaans (Zuid)', 'Kosovaars', 'Kroatisch', 'Lets', 'Libanees', 'Liberiaans', 'Libisch', 'Litouws', 'Luxemburgs', 'Madagaskisch', 'Malawisch', 'Maleisisch', 'Maltees', 'Marokkaans', 'Mexicaans', 'Moldavisch', 'Mongools', 'Montenegrijn', 'Myanmar', 'Namibisch', 'Nederlands', 'Nepalees', 'Nicaraguaans', 'Niet toegewezen', 'Nieuw-Zeelands', 'Nigeraans', 'Nigeriaans', 'N-Macedonisch', 'Noors', 'Noors (Svalbad)', 'Oekraïens', 'Oezbekistaans', 'Omaans', 'Oostenrijks', 'Pakistaans', 'Palestijns', 'Panamees', 'Paraguayaans', 'Peruviaans', 'Pools', 'Portugees', 'Qatarees', 'Roemeens', 'Russisch', 'Rwandees', 'Salvadoraans', 'Saudi-Arabisch', 'Serv.-Monteneg.', 'Servisch', 'Seychels', 'Singaporees', 'Sloveens', 'Slowaaks', 'Somalisch', 'Spaans', 'Srilankaans', 'Sudanees', 'Surinaams', 'Swazisch', 'Syrisch', 'Tadzjieks', 'Taiwanees', 'Tanzaniaans', 'Thais', 'Togolees', 'Tsjechisch', 'Tunesisch', 'Turks', 'Ugandees', 'Uruguayaans', 'V. PapoeaNwGuin', 'v. St. Kitts &', 'v. Trinidad & T', 'Vaderlandsloos', 'Venezolaans', 'Vietnamees', 'Wit-Russisch', 'Zambiaans', 'Zimbabwaans', 'Zuid-Afrikaans', 'Zweeds', 'Zwitsers']
    }
  },
  mounted () {
    if (this.options.includes(this.value)) {
      this.localValue = this.value
    } else {
      this.handleChange(null)
    }
  },
  methods: {
    handleChange (val) {
      this.$emit('input', val)
      this.v?.$touch()
    }
  },
  watch: {
    value () {
      this.localValue = this.value
    }
  }
}
</script>
